// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let colourEnum = {
    'Red': 0,
    'Orange': 1,
    'Yellow': 2,
    'Green': 3,
    'Blue': 4,
    'Purple': 5,
    'Pink': 6,
    'Black': 7,
    'White': 8
};

export default colourEnum;
